import React from 'react';
import SvgIcon, {
  SvgIconProps,
} from '@mui/material/SvgIcon';

export default function DollarCircleIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="none"
        d="M27.5 15C27.5 21.9035 21.9035 27.5 15 27.5C8.09644 27.5 2.5 21.9035 2.5 15C2.5 8.09644 8.09644 2.5 15 2.5C21.9035 2.5 27.5 8.09644 27.5 15Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        fill="none"
        d="M18.3877 12.5749C18.2639 11.6216 17.1692 10.0813 15.201 10.0813C12.914 10.0812 11.9517 11.3479 11.7564 11.9812C11.4518 12.8283 11.5127 14.5699 14.1934 14.7598C17.5442 14.9973 18.8866 15.3928 18.7159 17.4435C18.545 19.4942 16.6771 19.9373 15.201 19.8897C13.7247 19.8423 11.3095 19.1642 11.2158 17.3402M14.9667 8.74609V10.0858M14.9667 19.8774V21.246"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </SvgIcon>
  );
}
